<template>
<div class="headdownload">
  <img class="logo" src="../../../public/image/Instrument/216.png">
  <div class="headdownload-center">
    <div class="headdownload-center-title">CC加速器</div>
    <div class="headdownload-center-txt">免费 稳定 极速</div>
  </div>
  <div class="headdownload-download" @click="openOfficial">下载</div>
</div>
</template>

<script>
export default {
  name: 'Headdownload',
  methods: {
    openOfficial () {
      this.$parent.openOfficial()
    }
  }
}
</script>

<style scoped lang="scss">
.headdownload{
  position: fixed;
  left: 0px;
  right: 0px;
  height: 60px;
  background: red;
  z-index: 999;
  background: url("../../../public/image/Instrument/157.png");
  display: flex;
  align-items: center;
  .logo{
    width: 46px;
    height: 46px;
    margin-left: 11px;
  }
  .headdownload-center{
    margin-left: 7px;
    .headdownload-center-title{
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #FFFFFF;

      background: linear-gradient(0deg, #2992FF 0%, #00F2C2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .headdownload-center-txt{
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .headdownload-download{
    width: 70px;
    height: 28px;
    background: #2992FF;
    border-radius: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 14px;
  }
}
</style>
